import { SVGProps } from "react";

const Indeterminate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.845}
    height={2.487}
    {...props}
  >
    <path
      fill="#fff"
      d="M11.233 2.487H.612A.612.612 0 0 1 0 1.875V.612A.612.612 0 0 1 .612 0h10.621a.612.612 0 0 1 .612.612v1.263a.612.612 0 0 1-.612.612"
      data-name="Path 24178"
    />
  </svg>
);
export default Indeterminate;
